var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.actions.length)?_c('div',{staticClass:"banner-actions"},[(_vm.actions.includes('cookieModalBtn'))?[_c('CookeModalBtn',{staticClass:"banner-actions__cookie-btn"})]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/ui-components/banner/components/BannerActions.vue?vue&type=template&id=68d28aae&
// module id = 1213
// module chunks = 0